module.exports = __webpack_public_path__ + "img/f5f7b760-8ea5-40ee-bfbf-ad371f5bd312.71b06003.jpg";